import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

//Account Redux states
import { RESUMEQUEUE_TASK } from './actionTypes';
import { resumeQueueTaskSuccessful, resumeQueueTaskFailed } from './actions';

// Include call API
import { getTasksAPI } from "../../../api/tasks";

const tasksAPI = getTasksAPI();

// Is user update successfull then direct plot user in redux.
function* resumeQueueTask({ payload: { task,token } }) {
    try {
        yield call(tasksAPI.resumeQueueTasks, task?.taskCode, token);

        // P01021-147: history.go() recargaba la página entera (perdiendo el filtro aplicado en
        // la tabla de tareas) — la página escucha loadingResumeQueueTask y refresca el listado.
        yield put(resumeQueueTaskSuccessful("ok"));
        
    } catch (error) {
        console.log(error)
        yield put(resumeQueueTaskFailed(error));
    }
}

export function* watchTaskUpdate() {
    yield takeEvery(RESUMEQUEUE_TASK, resumeQueueTask);
}

function* resumeQueueTaskSaga() {
    yield all([fork(watchTaskUpdate)]);
}

export default resumeQueueTaskSaga;